import { useMutation } from 'react-query';

import { deleteRegistration } from '../../../../../services/api';

export const useDeleteRegistration = () => {
  const { mutate, isLoading } = useMutation((registrationId: string) => deleteRegistration(registrationId));

  return { deleteRegistration: mutate, isLoading };
};
